import { BusinessArea } from '../../Enums/BusinessArea';
import { LegalUnit } from '../../Enums/LegalUnit';
import { ResponsibleType } from '../../Enums/ResponsibleType';
import { getActiveAgentWithLowestCode, getBusinessAreaByChannel } from '../../Helpers/AgentHelper';

export const areBrokerFunctionsAvailable = team => {
  return !areDecoupledFunctionsAvailableFunction(team);
};

export const areDecoupledFunctionsAvailableFunction = team => {
  //If it is Private BA or SE Com Internal (decoupled) then shouldn't use BankAccount and extension parameters "Group Email", "Digital", "XML Export".
  //Otherwise if it is commercial extension functionalities shoud be available.But name shouldn't displayed and  rename operation not allowed
  return (
    !areAgentsSetForTeam(team) ||
    getBusinessArea(team) === BusinessArea.Private ||
    (getLegalUnit(team) === LegalUnit.Sweden &&
      getBusinessArea(team) === BusinessArea.Commercial &&
      team?.responsibleType === ResponsibleType.Internal)
  );
};

const areAgentsSetForTeam = team => {
  return team?.agents?.length > 0;
};

const getBusinessArea = team => {
  return getBusinessAreaByChannel(getActiveAgentWithLowestCode(team)?.channel);
};

export const getLegalUnit = team => {
  return getActiveAgentWithLowestCode(team)?.region?.legalUnitName;
};

export const canParentTeamBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};

export const canTeamMobileNumberBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};

export const canTeamNameBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};

export const mapGetTeamResponse = team => {
  return { ...team, commonAgentName: team.firstAgentName };
};

export const isCommonAgentNameMandatory = team => {
  return areDecoupledFunctionsAvailableFunction(team);
};

export const canAgentNameBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};

export const canEmployerBeSet = employers => {
  return employers?.length > 0;
};

export const canCommissionEnabledBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};

export const mapLocationStateToTeam = state => {
  return { ...state, commonAgentName: state?.name };
};

export const canTeamResponsibleTypeBeSet = legalUnitName => {
  return legalUnitName === LegalUnit.Denmark;
};
